import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  leerServicioActivoLocal,
  verificarServicioActivoRemoto,
} from "../../utils/servicioActivo";

function resolveServicioData() {
  const data = leerServicioActivoLocal();
  if (data?.cronogramaId) return data;

  let user = {};
  try {
    user = JSON.parse(localStorage.getItem("user") || "{}") || {};
  } catch {
    user = {};
  }
  if (user.servicioActivo) {
    return {
      cronogramaId: user.servicioActivo.toString(),
      inicio: user.servicioInicio ? new Date(user.servicioInicio).getTime() : Date.now(),
      acumuladoSegundos: 0,
    };
  }
  return null;
}

export default function ServicioActivoFloating() {
  const navigate = useNavigate();
  const [display, setDisplay] = useState(null);
  const [verificando, setVerificando] = useState(false);
  const verificadoInicial = useRef(false);

  useEffect(() => {
    const tick = () => {
      const data = resolveServicioData();
      if (!data) {
        setDisplay(null);
        return;
      }
      const diff = Math.max(0, Math.floor((Date.now() - data.inicio) / 1000));
      setDisplay({
        cronogramaId: data.cronogramaId,
        segundos: (data.acumuladoSegundos || 0) + diff,
      });
    };

    tick();
    const i = setInterval(tick, 1000);
    return () => clearInterval(i);
  }, []);

  // Al detectar un servicio en cache, confirmarlo una vez con el servidor
  // (puede haber sido finalizado, eliminado o liberado por un administrador).
  const hayServicio = !!display;
  useEffect(() => {
    if (!hayServicio) {
      verificadoInicial.current = false;
      return;
    }
    if (verificadoInicial.current) return;
    verificadoInicial.current = true;
    verificarServicioActivoRemoto().catch(() => {});
  }, [hayServicio]);

  if (!display) return null;

  const { segundos } = display;
  const mins = Math.floor(segundos / 60);
  const secs = String(segundos % 60).padStart(2, "0");

  const handleClick = async () => {
    if (verificando) return;
    setVerificando(true);
    try {
      const estado = await verificarServicioActivoRemoto();
      if (estado.activo) {
        navigate(`/manage/${estado.servicioActivo}`);
      } else {
        toast.info(
          estado.motivo
            ? `El servicio se cerró: ${estado.motivo}. Ya puedes iniciar uno nuevo.`
            : "No tienes un servicio en ejecución.",
        );
      }
    } catch (err) {
      if (err?.response) {
        toast.error(
          err.response.data?.message || "No se pudo verificar el servicio activo",
        );
      } else {
        // Sin conexión: intentar abrir con el dato local
        navigate(`/manage/${display.cronogramaId}`);
      }
    } finally {
      setVerificando(false);
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={verificando}
      className="fixed bottom-6 right-6 bg-blue-600 text-white px-4 py-3 rounded-full shadow-xl z-50 disabled:opacity-70"
    >
      ⏱️ {mins}:{secs}
    </button>
  );
}
